/**
 * SOLID Review
 * S — Strong. One concern: the QR modal closes on Escape.
 * O — Good. Another key is one more line.
 * L — Strong. A view model (`IServiceViewModel`) with no state a view renders.
 * I — Strong. The view's one input.
 * D — Strong. The platform's page events.
 */
import type { IServiceViewModel } from './IServiceViewModel';
import { Reactions } from './Reactions';
import type { IServicePageEvents } from './platform/IConfigDepViewPlatform';

/** What the modal's view hands it: how it closes. */
type TQrInputs = readonly [onClose: () => void];

const NO_STATE: Readonly<Record<string, never>> = Object.freeze({});

/** THE QR MODAL'S ESCAPE (frontend-framework-oo P4, 2026-10-29, §28.296) — `components/game/QRModal.tsx`'s effect. */
export class QrModalViewModel implements IServiceViewModel<typeof NO_STATE> {
  private readonly reactions = new Reactions<TQrInputs>([{
    deps: (inputs) => inputs,
    run: ([onClose]) => this.events.on('keydown', (event) => {
      if ((event as KeyboardEvent).key === 'Escape') onClose();
    }),
  }]);

  constructor(private readonly events: IServicePageEvents) {}

  getSnapshot(): typeof NO_STATE {
    return NO_STATE;
  }

  subscribe(): () => void {
    return () => undefined;
  }

  attach(): void {}

  detach(): void {
    this.reactions.stop();
  }

  release(inputs: readonly unknown[]): void {
    this.reactions.stopChanged(inputs as TQrInputs);
  }

  commit(inputs: readonly unknown[]): void {
    this.reactions.startChanged(inputs as TQrInputs);
  }
}
